'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = launch;

var _launch = require('../actions/launch');

function launch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _launch.SET_LAUNCH_RAW_DATA:
      return { rawData: action.rawData };
    case _launch.CLEAR_LAUNCH_RAW_DATA:
      return { rawData: [] };
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/launch.js
// module id = 2350
// module chunks = 0